import { render, staticRenderFns } from "./personalDetails.vue?vue&type=template&id=53b56246&scoped=true"
import script from "./personalDetails.vue?vue&type=script&lang=js"
export * from "./personalDetails.vue?vue&type=script&lang=js"
import style0 from "./personalDetails.vue?vue&type=style&index=0&id=53b56246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b56246",
  null
  
)

export default component.exports